import { render, staticRenderFns } from "./HeaderTitleLoader.vue?vue&type=template&id=45605f50&scoped=true"
import script from "./HeaderTitleLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderTitleLoader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HeaderTitleLoader.vue?vue&type=style&index=0&id=45605f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45605f50",
  null
  
)

export default component.exports